module.exports = __webpack_public_path__ + "img/34_27.6fc14103.png";